import { createStore } from 'vuex'

import careerElements from "../json/career.json"
import navLinks from "../json/navbar.json"
import homeElements from "../json/home.json"

export default createStore({
  state: {
    themeStatus: true,
    navStatus: false,
    show: true,
    language: "En",
    careerElements,
    homeElements,
    navLinks
  },
  getters: {
    navLanguageLinks(state) {
      return state.navLinks[state.language]
    },
    careerLanguageElements(state) {
      return state.careerElements[state.language]
    },
    homeLanguageElements(state) {
      return state.homeElements[state.language]
    }
  },
  mutations: {
    changeThemeStatus(state, status) {
      state.themeStatus = status;
    },
    changeNavStatus(state) {
      state.navStatus = !state.navStatus;
    },
    async changeLanguage(state, language) {
      state.show = false;
      await new Promise(time => setTimeout(() => time(), 1000));
      state.show = true;
      state.language = language;
    }

  },
  actions: {
  },
  modules: {
  }
})
